<template>
	<section :class="['block-wrapper', componentClass, colorMode, {visible: visible, ready: ready}]">
		<div class="row">
			<div class="columns small-12 medium-10 medium-offset-1 large-8 large-offset-2">
				<h1>{{ data.title || 'Cookies' }}</h1>
				<div v-if="sanitizedTextAfterTitle" v-html="sanitizedTextAfterTitle" id="custom-site-cookie-text"></div>
				<div ref="consentWrapper"></div>
			</div>
		</div>
	</section>
</template>

<script>
import BaseBlock from 'RuterSharedBlocks/Base'
import DOMPurify from 'dompurify';
export default {
	extends: BaseBlock,
	data() {
		return {
			defaultColorMode: 'light',
			componentClass: 'cookiebot-consent-page',
		}
	},
	computed: {
		sanitizedTextAfterTitle() {
			if (typeof this.data.text_after_title === 'undefined') return false;
			return DOMPurify.sanitize(this.data.text_after_title)
		}
	},
	mounted() {
		if (typeof this.$cookiebot !== 'undefined') this.$cookiebot.consentPage({
			async: true,
			locale: this.$i18n.locale,
			ref: this.$refs.consentWrapper
		})
	}
}
</script>

<style lang="scss">
	@import "DcVueCookiebot/styles/scss/component/_cookiebot-consent-page.scss";
</style>